import React, { ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import styles from './IcoButton.module.scss';

interface IcoButtonInterface {
  handleClick?: (ev: any) => void; // eslint-disable-line no-unused-vars
  icon?: string;
  disabled?: boolean;
  id: string;
  tooltipText?: string;
  tooltipDisable?: string;
  noMargin?: boolean;
  selected?: boolean;
  active?: boolean;
  iconComponent?: ReactElement;
  customClass?: string;
}

const CustomTooltip = withStyles(() => ({ tooltip: { fontSize: 13 } }))(Tooltip);

const IcoButton: React.FC<IcoButtonInterface> = ({ handleClick = () => { }, icon, disabled = false, id, tooltipText = '',
  tooltipDisable = '', noMargin = false, selected = false, active = false, iconComponent = null, customClass = '', ...props }) => {
  const className = noMargin ? `di ${icon} m0` : `di ${icon}`;
  const classes = `${styles.IcoButton} ${selected ? styles.BtnSelected : ''} ${active ? styles.Active : ''} ${customClass}`;
  const tooltipTitle = disabled ? tooltipDisable : tooltipText;

  // if have empty string in the title the tooltip is not shown
  return (
    <CustomTooltip title={tooltipTitle || ''}>
      <button
        id={id}
        data-testid={id}
        type="button"
        className={classes}
        onClick={handleClick}
        disabled={disabled}
        {...props}
      >
        <i className={className}> {iconComponent || ''} </i>
      </button>
    </CustomTooltip>
  );
};

export default React.memo(IcoButton, (prev, next) => (
  JSON.stringify(prev) === JSON.stringify(next)
));

export { IcoButton as IcoButtonSimple };
